<template>
  <div>
    <div v-if="person">
      <p class="font-black text-4xl leading-tight mb-3">
        {{ $t("professionalRating.failedId.title") }}
      </p>
      <p class="font-light text-2xl leading-tight mb-20">
        {{
          $t("professionalRating.failedId.noJobFound", {
            mateName: person.name,
          })
        }}
      </p>
      <p class="font-black text-2xl leading-tight mb-3">
        {{ $t("professionalRating.failedId.correctEmailQuestion") }}
      </p>
      <p class="font-light text-2xl leading-tight mb-10">
        <i18n path="professionalRating.failedId.checkYourPhone">
          <template #link>
            <NuxtLink
              :to="
                localePath({
                  name: 'professionalPage',
                  params: { professionalSeoName: person.seoName },
                })
              "
            >
              {{
                $t("professionalRating.failedId.checkYourPhoneLink", {
                  mateName: person.name,
                })
              }}
            </NuxtLink>
          </template>
        </i18n>
      </p>
      <p class="font-black text-2xl leading-tight mb-3">
        {{
          $t("professionalRating.failedId.areYouSure", {
            mateName: person.name,
          })
        }}
      </p>
      <p class="font-light text-2xl leading-tight mb-10">
        <i18n path="professionalRating.failedId.checkProfile">
          <template #link>
            <NuxtLink :to="localePath({ name: 'myTenders' })">
              {{ $t("professionalRating.failedId.checkProfileLink") }}
            </NuxtLink>
          </template>
        </i18n>
      </p>
      <p class="font-black text-2xl leading-tight mb-3">
        {{ $t("professionalRating.failedId.anotherErrorQuestion") }}
      </p>
      <p class="font-light text-2xl leading-tight mb-10">
        <i18n path="professionalRating.failedId.emailUs">
          <template #link>
            <a :href="$helpers.support.emailLink">{{
              $helpers.support.email
            }}</a>
          </template>
        </i18n>
      </p>
    </div>
    <div class="mb-3 flex text-3xl font-bold justify-center">
      <JoszakiButton @click="restart">
        {{ $t("professionalRating.failedId.restart") }}
      </JoszakiButton>
    </div>
    <div class="mb-10 text-center text-[#4a4a4a]">
      <NuxtLink to="/">
        {{ $t("professionalRating.failedId.goToHomePage") }}
      </NuxtLink>
    </div>
  </div>
</template>

<script>
import { useRating } from "~/components/_refactored/rating/useRating";

export default {
  setup() {
    const rating = useRating();

    return { rating };
  },
  computed: {
    person() {
      return this.rating.state.person;
    },
  },
  methods: {
    restart() {
      this.rating.restart();
    },
  },
};
</script>
